import React from "react";
import { API, Storage } from "aws-amplify";

import {
  useNotify,
  useRedirect,
  useEditController,
  Edit,
  Loading,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { logError } from "../../../utils/appUtils";
import { getDirFileKey, removeFile } from "../../../utils/fileUtils";
import { FilePaths } from "../../../utils/constants";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { FileHelp } from "./FileHelp";
import { DeepDeleteButton } from "./DeepDeleteButton";
import { FileSetupTab } from "./FileSetupTab";

const FileEditActions = ({ notify, basePath, data, resource, ...props }) => {
  return (
    <TopToolbar>
      <HelpButton>
        <FileHelp {...props} />
      </HelpButton>
      <BackButton basePath={basePath} />
    </TopToolbar>
  );
};

export const FileEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { record } = useEditController(props);

  const transform = async (data) => {
    data = { ...data };
    try {
      debugger;
      if (!data.file) await removeFile(record, data, "file");
      else if (data.file && !data.file.key) {
        if (record.file) await removeFile(record, null, "file");

        const key = getDirFileKey(data.file.rawFile, FilePaths.DOCUMENTS);
        const response = await Storage.put(key, data.file.rawFile, {
          level: "public",
          contentType: data.file.rawFile.type,
        });

        if (response.key) {
          data.rawFileName = data.file.rawFile.name;
          if (data.file.rawFile.lastModifiedDate)
            data.contentDate = data.file.rawFile.lastModifiedDate;

          data.file = {
            bucket: API._options.aws_user_files_s3_bucket,
            region: API._options.aws_user_files_s3_bucket_region,
            key: response.key,
          };
        } else throw new Error(`Storage.put failed: ${key}`);
      }

      if (data.file) {
        delete data.file.src;
        delete data.file.title;
      }
    } catch (error) {
      logError("files:FileEdit:transform", error, notify);
      return Promise.reject();
    }

    delete data.fileCategories;

    return data;
  };

  const onSuccess = async (data) => {
    notify("File updated successfully", "success");
    redirect("list", props.basePath);
  };

  const onFailure = (error) => {
    logError("files:FileEdit:onFailure", error, notify);
  };

  const FileEditToolbar = (props) => (
    <Toolbar
      style={{ justifyContent: "space-between" }}
      record={record}
      {...props}
    >
      <SaveButton
        label="Save"
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
      <DeepDeleteButton />
    </Toolbar>
  );

  if (!record) return <Loading />;
  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Document" />}
      mutationMode="pessimistic"
      actions={<FileEditActions notify={notify} {...props} />}
    >
      <SimpleForm submitOnEnter={false} toolbar={<FileEditToolbar />}>
        <FileSetupTab />
      </SimpleForm>
    </Edit>
  );
};
